import { render, staticRenderFns } from "./officialAlert.vue?vue&type=template&id=cacde5dc&"
import script from "./officialAlert.vue?vue&type=script&lang=js&"
export * from "./officialAlert.vue?vue&type=script&lang=js&"
import style0 from "./officialAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports